export default "__VITE_ASSET__CPYeYfRI__"